export default __webpack_public_path__ + "static/IncentiveMechanism-e4834fcb10b247ca4dbd9d6e0de98cec.png";